/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/content-ai-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/content-ai-api-client";
import type { ContentListQueryResponse, ContentListQueryParams } from "../models/ContentList";

export function getContentListUrl() {
  const res = { method: 'GET', url: `/contents` as const }  
  return res
}

/**
 * @summary List contents
 * {@link /contents}
 */
export async function contentList(params?: ContentListQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ContentListQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getContentListUrl().url.toString(), params, ... requestConfig })  
  return res.data
}